import {useCallback, useRef, useState} from "react";

interface SelectionRange {
    start: number;
    end: number;
    text: string;
}

const useHighlight = () => {
    const [selectionText, setSelectionText] = useState("")
    const [selection, setSelection] = useState({
        start: 0,
        end: 0,
        text: '',
    })
    const refInput = useRef<HTMLTextAreaElement | HTMLInputElement | null>(null)

    const handleMouseUp = () => {
        const selection = window.getSelection()
        if (selection && selection.toString().length > 0) {
            setSelectionText(selection.toString());
        } else {
            setSelectionText('')
        }
    };

    // This special for inputs as text area
    const getSelectionRange = useCallback((input: HTMLTextAreaElement | HTMLInputElement | null): SelectionRange | null => {
        try {
            if (!input) return null;

            const selectionStart = input.selectionStart;
            const selectionEnd = input.selectionEnd;
            if (selectionStart === null || selectionEnd === null) return null;

            const selectedText = input.value.substring(selectionStart, selectionEnd);
            return {
                start: selectionStart,
                end: selectionEnd,
                text: selectedText,
            };
        } catch (error) {
            console.error('Error getting selection range:', error);
            return null;
        }
    }, []);

    const handleSelection = () => {
        if (refInput.current) {
            const range = getSelectionRange(refInput.current);
            if (range?.text){
                setSelection(range);
                setSelectionText(range.text);
            }else{
                setSelectionText('');
                setSelection({
                    start: 0,
                    end: 0,
                    text: '',
                })
            }
        }
    };

    return {selectionText, handleMouseUp, setSelectionText, handleSelection, refInput, selection}
}

export default useHighlight